import { render } from "./Vail.vue?vue&type=template&id=2f8d0dda"
import script from "./Vail.vue?vue&type=script&lang=js"
export * from "./Vail.vue?vue&type=script&lang=js"

import "./Vail.vue?vue&type=style&index=0&id=2f8d0dda&lang=css"
script.render = render

export default script